import { useState } from 'react';
import Title from '../custom/Title';
import CustomTabs from '../custom/newTabs';
import { OutgoingRequest } from '../$PVCInventory/OutgoingRequest';
import { IncomingRequest } from '../$PVCInventory/IncomingRequest';

function InventoryRequestTabs() {
    const [value, setValue] = useState(0);

    return (
        <>
            <CustomTabs
                labels={[
                    'Outgoing Request',
                    'Incoming Request',
                ]}
                TabContents={[
                    <OutgoingRequest />,
                    <IncomingRequest />
                ]}
                value={value}
                handleChange={setValue}
            />
        </>
    )
}

export const InventoryRequest = () => {
    return (
        <div style={{ padding: '0 10px' }}>
            <div style={{ borderBottom: '1px solid #d8d8d8' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Inventory Requests</Title>
            </div>
            <InventoryRequestTabs />
        </div>
    )
}


